import * as React from "react";
import { getAddressFormatted, isAddressComplete } from "src/utils/address/addressUtil";
import { Slot } from "src/containers/event/event.types";
import { EventSlotType } from "api/events/event.types";
import { AddressType } from "common/event/event.types";

interface SlotLocationProps {
  slot: Slot;
  isBookedOrFull?: boolean;
}

export const SlotLocation: React.FC<SlotLocationProps> = ({ slot, isBookedOrFull }) => {
  const displayEventVenue = slot.type === EventSlotType.GroupLunch && slot.addressType === AddressType.BusinessAddress;
  const addressToDisplay =
    displayEventVenue && slot.eventVenue
      ? { ...slot.eventVenue.address, venueName: slot.eventVenue.name }
      : slot.address;

  return isAddressComplete(addressToDisplay) ? (
    <div className={`d-flex flex-column align-items-start w-100 p-2 gap-2 ${isBookedOrFull ? "bg-lvl2" : "bg-lvl1"}`}>
      <div className="d-flex align-items-center gap-1">
        <span className="icon icon-sm">place</span>
        <span className="fs-16 fw-semibold">Location</span>
      </div>
      <span className="fs-14 text-secondary ms-4">{getAddressFormatted(addressToDisplay)}</span>
    </div>
  ) : (
    <></>
  );
};
